import { datetimeCovertertolocal } from '../../datetime-converter';
import { ASN_DATA_LIST, ASN_DATA_LIST_SUCCESS, ASN_DATA_LIST_ERROR } from './constants';
import { ASN_DATA_DETAILS, ASN_DATA_DETAILS_SUCCESS, ASN_DATA_DETAILS_ERROR } from './constants';
import { ADD_ASN_DATA_DETAILS, ADD_ASN_DATA_DETAILS_SUCCESS, ADD_ASN_DATA_DETAILS_ERROR } from './constants';
import { UPDATE_ASN_DATA, UPDATE_ASN_DATA_SUCCESS, UPDATE_ASN_DATA_ERROR } from './constants';
import { DELETE_ASN_DATA, DELETE_ASN_DATA_SUCCESS, DELETE_ASN_DATA_ERROR } from './constants';

// IMPORTANT: import this from the same place your Task list reducer does
// import { datetimeCovertertolocal } from '<same path as in your task reducer>';

export default function asnDataReducer(state, action) {
	let asnData = [];
	let pagination = {};

	switch (action.type) {
	case ASN_DATA_LIST:
		return { ...state, pending: true };

	case ASN_DATA_LIST_SUCCESS:
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize = action.pageSize ? action.pageSize : 10;

			action.payload.data.forEach((item) => {
				const dt = datetimeCovertertolocal(item.datetime ? item.datetime : '<Not Set>');
				const newdatetime = item.datetime ? (dt.localdate + ' ' + dt.localtime) : '<Not Set>';

				asnData.push({
					id: item.id ? item.id : 0,
					name: item.name ? item.name : '',
					latitude: item.latitude !== null && item.latitude !== undefined ? item.latitude : null,
					longitude: item.longitude !== null && item.longitude !== undefined ? item.longitude : null,
					speed: item.speed !== null && item.speed !== undefined ? item.speed : null,
					datetime: newdatetime,        // shown in the table (local time)
					datetimeUTC: item.datetime    // raw value used by the edit modal
				});
			});

			return { ...state, asnData: asnData, pending: false, error: false, pagination: pagination };
		} else if (action.payload && action.payload.data && action.payload.data.length === 0) {
			return {
				...state,
				asnData: [],
				pending: false,
				error: false,
				pagination: { total: 0, limit: 10, skip: 0, current: 1, pageSize: 10 }
			};
		} else {
			return { ...state, asnData: [], pending: false, error: true };
		}

	case ASN_DATA_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case ASN_DATA_DETAILS:
		return { ...state, pending: true };

	case ASN_DATA_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case ASN_DATA_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_ASN_DATA_DETAILS:
		return { ...state, pending: false };

	case ADD_ASN_DATA_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_ASN_DATA_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_ASN_DATA:
		return { ...state, pending: false };

	case UPDATE_ASN_DATA_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_ASN_DATA_ERROR:
		return { ...state, pending: false, error: true };

	case DELETE_ASN_DATA:
		return { ...state, pending: false };

	case DELETE_ASN_DATA_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_ASN_DATA_ERROR:
		return { ...state, pending: false, error: true };

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}